import { IPagedCollection, IPagingData, MediaInfoDto } from '@sr/dto';
import { mediaApi } from 'entities/media/api-slice';
import { MEDIA_BASE_URL } from 'shared/api/api';
import { CollectionParams } from 'shared/api/rtk-query';
import { pagingDataToParams } from 'utils/remote-paged-collection.hook';

const injectedApi = mediaApi.injectEndpoints({
  endpoints: (builder) => ({
    getMediaList: builder.query<IPagedCollection<MediaInfoDto>, CollectionParams>({
      query: ({ paging, filter }: CollectionParams) => ({
        url: `${MEDIA_BASE_URL}?${filter}`,
        params: paging && pagingDataToParams(paging),
        method: 'GET'
      })
    }),
    getMedia: builder.query<IPagedCollection<MediaInfoDto>, { id: number; paging: IPagingData; filter: string }>({
      query: ({ id, paging, filter }) => ({
        url: `${MEDIA_BASE_URL}/${id}/cities?${filter}`,
        params: paging && pagingDataToParams(paging),
        method: 'GET'
      })
    }),
    deleteMedia: builder.mutation<void, number>({
      query: (linkId: number) => ({
        url: `${MEDIA_BASE_URL}/${linkId}`,
        method: 'DELETE'
      })
    }),
    deleteMedias: builder.mutation<void, number[]>({
      query: (ids: number[]) => ({
        url: MEDIA_BASE_URL,
        method: 'DELETE',
        body: { ids }
      })
    })
  }),
  overrideExisting: true
});

export const mediaListApi = injectedApi.enhanceEndpoints({
  endpoints: {
    getMediaList: {
      providesTags: (result: IPagedCollection<MediaInfoDto> | undefined) =>
        result
          ? [
            ...result.items.map(({ id }) => ({ type: 'MediaList' as const, id })),
            { type: 'MediaList' as const, id: 'LIST' as const }
          ]
          : [{ type: 'MediaList' as const, id: 'LIST' as const }]
    },
    getMedia: {
      providesTags: (result: IPagedCollection<MediaInfoDto> | undefined) =>
        result
          ? [
            ...result.items.map(({ id }) => ({ type: 'MediaCities' as const, id })),
            { type: 'MediaCities' as const, id: 'LIST' as const }
          ]
          : [{ type: 'MediaCities' as const, id: 'LIST' as const }]
    },
    deleteMedia: {
      invalidatesTags: [
        { type: 'MediaList' as const, id: 'LIST' as const },
        { type: 'MediaCities' as const, id: 'LIST' as const }
      ]
    },
    deleteMedias: {
      invalidatesTags: [
        { type: 'MediaList' as const, id: 'LIST' as const },
        { type: 'MediaCities' as const, id: 'LIST' as const }
      ]
    }
  }
});
